import Vue from 'vue'
import Router from 'vue-router'
import Main from './layouts/main.vue'

import store from '@/store'

Vue.use(Router)

const guardGuest = (to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  if (isLoggedIn) {
    next('/')
  } else {
    next()
  }
}
const guardAuth = (to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn']
  if (isLoggedIn) {
    next()
  } else {
    next('/login')
  }
}

export default new Router({
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/login.vue'),
      beforeEnter: guardGuest
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () => import('./views/auth/forgot.vue'),
      beforeEnter: guardGuest
    },
    {
      path: '/reset-password',
      name: 'reset-password',
      component: () => import('./views/auth/resetPassword.vue'),
      beforeEnter: guardGuest
    },
    {
      path: '/',
      component: Main,
      beforeEnter: guardAuth,
      children: [
        {
          path: '/',
          name: 'dashboard',
          component: () => import('./views/index.vue'),
          meta: { stack: [{ title: 'Dashboard', to: '/' }] }
        },
        {
          path: '/profile',
          name: 'profile',
          component: () => import('./views/profile.vue'),
          meta: { stack: [{ title: 'Profile', to: '/profile' }] }
        },
        {
          path: '/client',
          name: 'client',
          component: () => import('./views/client/read.vue'),
          meta: { stack: [{ title: 'Client', to: '/client' }] }
        },
        {
          path: '/client/create',
          name: 'client.create',
          component: () => import('./views/client/create.vue'),
          meta: {
            stack: [
              { title: 'Client', to: '/client' },
              { title: 'New Client', to: '/client/create' }
            ]
          }
        },
        {
          path: '/client/update/:id',
          name: 'client.update',
          component: () => import('./views/client/update.vue'),
          props: true,
          meta: {
            stack: [
              { title: 'Client', to: '/client' },
              { title: 'Edit Client', to: '/client/update' }
            ]
          }
        },
        {
          path: '/project',
          name: 'project',
          component: () => import('./views/project/read.vue'),
          meta: { stack: [{ title: 'Project', to: '/project' }] }
        },
        {
          path: '/project/create',
          name: 'project.create',
          component: () => import('./views/project/upsert.vue'),
          meta: {
            stack: [
              { title: 'Project', to: '/project' },
              { title: 'New Project', to: '/project/create' }
            ]
          }
        },
        {
          path: '/project/update/:id',
          name: 'project.update',
          component: () => import('./views/project/upsert.vue'),
          props: true,
          meta: {
            stack: [
              { title: 'Project', to: '/project' },
              { title: 'Edit Project', to: '/project/update' }
            ]
          }
        },
        {
          path: '/driver',
          name: 'driver',
          component: () => import('./views/driver/read.vue'),
          meta: { stack: [{ title: 'Driver', to: '/driver' }] }
        },
        {
          path: '/driver/create',
          name: 'driver.create',
          component: () => import('./views/driver/create.vue'),
          meta: {
            stack: [
              { title: 'Driver', to: '/driver' },
              { title: 'New Driver', to: '/driver/create' }
            ]
          }
        },
        {
          path: '/driver/update/:id',
          name: 'driver.update',
          component: () => import('./views/driver/update.vue'),
          props: true,
          meta: {
            stack: [
              { title: 'Driver', to: '/driver' },
              { title: 'Edit Driver', to: '/driver/update' }
            ]
          }
        },
        {
          path: '/gateway',
          name: 'gateway',
          component: () => import('./views/gateway/read.vue'),
          meta: { stack: [{ title: 'Gateway', to: '/gateway' }] }
        },
        {
          path: '/gateway/create',
          name: 'gateway.create',
          component: () => import('./views/gateway/create.vue'),
          meta: {
            stack: [
              { title: 'Gateway', to: '/gateway' },
              { title: 'New Gateway', to: '/gateway/create' }
            ]
          }
        },
        {
          path: '/gateway/update/:id',
          name: 'gateway.update',
          component: () => import('./views/gateway/update.vue'),
          props: true,
          meta: {
            stack: [
              { title: 'Gateway', to: '/gateway' },
              { title: 'Edit Gateway', to: '/gateway/update' }
            ]
          }
        },
        {
          path: '/user',
          name: 'user',
          component: () => import('./views/user/read.vue'),
          meta: { stack: [{ title: 'User Manager', to: '/user' }] }
        },
        {
          path: '/user/create',
          name: 'user.create',
          component: () => import('./views/user/create.vue'),
          meta: {
            stack: [
              { title: 'User Manager', to: '/user' },
              { title: 'New User', to: '/user/create' }
            ]
          }
        },
        {
          path: '/user/update/:id',
          name: 'user.update',
          component: () => import('./views/user/update.vue'),
          props: true,
          meta: {
            stack: [
              { title: 'User Manager', to: '/user' },
              { title: 'Edit User', to: '/user/update' }
            ]
          }
        },
        {
          path: '/role',
          name: 'role',
          component: () => import('./views/role/read.vue'),
          meta: { stack: [{ title: 'Roles', to: '/role' }] }
        },
        {
          path: '/role/create',
          name: 'role.create',
          component: () => import('./views/role/create.vue'),
          meta: {
            stack: [
              { title: 'Roles', to: '/role' },
              { title: 'New Role', to: '/role/create' }
            ]
          }
        },
        {
          path: '/role/update/:id',
          name: 'role.update',
          component: () => import('./views/role/update.vue'),
          props: true,
          meta: {
            stack: [
              { title: 'Roles', to: '/role' },
              { title: 'Edit Role', to: '/role/update' }
            ]
          }
        },
        {
          path: '/permission',
          name: 'permission',
          component: () => import('./views/permission/read.vue'),
          meta: { stack: [{ title: 'Permissions', to: '/permission' }] }
        },
        {
          path: '/permission/create',
          name: 'permission.create',
          component: () => import('./views/permission/create.vue'),
          meta: {
            stack: [
              { title: 'Permissions', to: '/permission' },
              { title: 'New Permission', to: '/permission/create' }
            ]
          }
        },
        {
          path: '/permission/update/:id',
          name: 'permission.update',
          component: () => import('./views/permission/update.vue'),
          props: true,
          meta: {
            stack: [
              { title: 'Permissions', to: '/permission' },
              { title: 'Edit Permission', to: '/permission/update' }
            ]
          }
        }
      ]
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
